export function formatIST(iso) {
    if (!iso) return "—";
    const d = typeof iso === "string" ? new Date(iso) : iso;
    return d.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
}

export function relative(iso) {
    if (!iso) return "";
    const d = typeof iso === "string" ? new Date(iso) : iso;
    const diff = Math.floor((Date.now() - d.getTime()) / 1000);
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
}

export function formatMoney(n) {
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(n || 0);
}

export function countdown(deadlineIso) {
    if (!deadlineIso) return { label: "—", state: "on-track" };
    const target = new Date(deadlineIso).getTime();
    const diff = target - Date.now();
    const state = diff < 0 ? "breached" : diff <= 2 * 3600 * 1000 ? "at-risk" : "on-track";
    const abs = Math.abs(diff);
    const h = Math.floor(abs / 3600000);
    const m = Math.floor((abs % 3600000) / 60000);
    const s = Math.floor((abs % 60000) / 1000);
    const pad = (x) => x.toString().padStart(2, "0");
    const sign = diff < 0 ? "-" : "";
    const label = `${sign}${pad(h)}:${pad(m)}:${pad(s)}`;
    return { label, state };
}
